/* eslint-disable max-lines */
export const INTERVIEW_TAB_KEYS = [
  'interview.suppliers.title',
  'interview.relativePrices.title',
  'interview.priceSensitivity.title',
  'interview.attributeImportance.title',
  'interview.scores.product.title',
  'interview.scores.service.title',
  'interview.scores.image.title',
  'interview.generalQuestions.title',
];

export enum INTERVIEW_TABS {
  SUPPLIERS,
  RELATIVE_PRICES,
  PRICE_SENSITIVITY,
  ATTRIBUTE_IMPORTANCE,
  PRODUCT_SCORES,
  SERVICE_SCORES,
  IMAGE_SCORES,
  GENERAL_QUESTIONS,
  FINISH,
  ATTRIBUTE_PERFORMANCE,
}

export enum INTERVIEW_CATEGORY {
  SUPPLIERS = 'SUPPLIERS',
  RELATIVE_PRICES = 'RELATIVE_PRICES',
  PRICE_SENSITIVITY = 'PRICE_SENSITIVITY',
  ATTRIBUTE_IMPORTANCE = 'ATTRIBUTE_IMPORTANCE',
  PRODUCT_SCORES = 'PRODUCT_SCORES',
  SERVICE_SCORES = 'SERVICE_SCORES',
  IMAGE_SCORES = 'IMAGE_SCORES',
  GENERAL_QUESTIONS = 'GENERAL_QUESTIONS',
}

export const INTERVIEW_LIST_MAX_LENGTH = 35;

export const INTERVIEW_TYPES: Record<string, string> = {
  F2F: 'F2F',
  WEB: 'Web',
  ZOOM: 'Zoom',
  TEAMS: 'Teams',
  GOOGLE_MEET: 'Google meet',
  PHONE: 'Phone',
  EXCEL: 'Excel',
  OTHER_VIRTUAL: 'Other',
};

export const DEFAULT_CATEGORY_VALUE = 'GENERAL_QUESTIONS';

export const COMMENTS_TEXT_FIELD_ROWS = 3;

export const LOCALIZATION_GROUPS = {
  CVA_INPUT: 'CVA_INPUT',
  CVA_PROJ: 'CVA_PROJ',
  ALL: 'ALL',
};

export const EN_LANG_CODE = 44;
export const DE_LANG_CODE = 49;

export enum INTERVIEW_PRIORITY {
  NO_PRIORITY,
  HIGH,
  MIDDLE,
  LOW,
}

export const ONE_BYTE = 1024;

export enum INTERVIEW_MODE {
  WIZARD,
  SHEET,
  EXCEL,
}

export const INPUT_METHOD_BUTTON_WIDTH = 220;

export const INTERVIEW_TYPE_TRANSLATION = {
  'interview.suppliers.title': 'CvaInput.Wizz0',
  'interview.relativePrices.title': 'CvaInput.Wizz1',
  'interview.priceSensitivity.title': 'CvaInput.Wizz3',
  'interview.attributeImportance.title': 'CvaInput.Wizz2',
  'interview.scores.product.title': 'CvaInput.Wizz41',
  'interview.scores.service.title': 'CvaInput.Wizz6',
  'interview.scores.image.title': 'CvaInput.Wizz7',
  'interview.generalQuestions.title': 'CvaInput.Wizz51',
};
